var flatten = require("./flatten"), overRest = require("./_overRest"), setToString = require("./_setToString");
function flatRest(func) {
  return setToString(overRest(func, void 0, flatten), func + "");
}
module.exports = flatRest;
